import { ObjectBase } from '@awesome-nodes/object';
import { Disposable } from "../model";
export class ViewModelBase extends ObjectBase {
  get name() {
    return this.toString();
  }

  get model() {
    return this._model;
  }

  set model(value) {
    this._model = value;
  }

  constructor(model, name) {
    super(name);
    this._model = void 0;
    this._model = model;
  }

  destroy() {
    this.model && (this.model instanceof Disposable || this.model.dispose) && this.model.dispose();
  }

  equals(other) {
    return super.equals(other) && this.name == other.name;
  }

}
